// Traducciones en Euskera
export default {
  // General
  appName: 'TorneosPro',
  loading: 'Kargatzen...',
  save: 'Gorde',
  cancel: 'Utzi',
  edit: 'Editatu',
  delete: 'Ezabatu',
  create: 'Sortu',
  add: 'Gehitu',
  new: 'Berria',
  search: 'Bilatu',
  searchTeam: 'Taldea bilatu...',
  searching: 'Bilatzen',
  noResultsFound: 'Ez da emaitzarik aurkitu',
  filter: 'Iragazi',
  all: 'Denak',
  active: 'Aktibo',
  inactive: 'Ez aktibo',
  yes: 'Bai',
  no: 'Ez',
  name: 'Izena',
  description: 'Deskribapena',
  status: 'Egoera',
  actions: 'Ekintzak',
  details: 'Xehetasunak',
  back: 'Atzera',
  next: 'Hurrengoa',
  previous: 'Aurrekoa',
  close: 'Itxi',
  confirm: 'Berretsi',
  optional: 'Aukerakoa',
  required: 'Derrigorrezkoa',
  language: 'Hizkuntza',
  share: 'Partekatu',
  copy: 'Kopiatu',
  copied: 'Kopiatuta',
  linkCopied: 'Esteka kopiatuta',

  // Errores y mensajes
  error: 'Errorea',
  success: 'Ondo',
  warning: 'Abisua',
  info: 'Informazioa',
  errorLoading: 'Errorea datuak kargatzean',
  errorSaving: 'Errorea gordetzean',
  errorDeleting: 'Errorea ezabatzean',
  savedSuccess: 'Ondo gordeta',
  deletedSuccess: 'Ondo ezabatuta',
  createdSuccess: 'Ondo sortuta',
  updatedSuccess: 'Ondo eguneratuta',
  confirmDelete: 'Ziur elementu hau ezabatu nahi duzula?',
  confirmDeleteTournament: 'Txapelketa ezabatu',
  deleteTournamentWarning: 'Talde, jokalari, partida eta gertaera GUZTIAK ezabatuko dira. Ekintza hau ezin da desegin.',
  tournamentDeletedCompletely: 'Txapelketa eta datu guztiak ondo ezabatu dira',
  noResults: 'Ez da emaitzarik aurkitu',
  requiredFields: 'Mesedez, bete derrigorrezko eremu guztiak',

  // Auth
  login: 'Saioa hasi',
  logout: 'Saioa itxi',
  loginWithGoogle: 'Google-rekin hasi saioa',
  welcomeBack: 'Ongi etorri berriz',
  accessDenied: 'Sarbidea ukatua',
  notApproved: 'Zure kontua oraindik ez da onartu',
  contactAdmin: 'Jarri harremanetan administratzailearekin',

  // Navegación
  dashboard: 'Panela',
  organizations: 'Erakundeak',
  tournaments: 'Txapelketak',
  teams: 'Taldeak',
  players: 'Jokalariak',
  matches: 'Partidak',
  forms: 'Izen-emateak',
  users: 'Erabiltzaileak',
  system: 'Sistema',
  settings: 'Ezarpenak',
  publicView: 'Ikuspegi publikoa',
  adminPanel: 'Admin Panela',
  home: 'Hasiera',
  welcome: 'Ongi etorri',
  managePlayers: 'Jokalari kudeaketa',
  manageTournaments: 'Txapelketa kudeaketa',
  manageTeams: 'Talde kudeaketa',
  manageOrganizations: 'Erakunde kudeaketa',
  manageMatches: 'Partida kudeaketa',
  manageUsers: 'Erabiltzaile kudeaketa',
  allTournaments: 'Txapelketa guztiak',
  allTeams: 'Talde guztiak',

  // Dashboard
  welcomeMessage: 'Ongi etorri administrazio panelera',
  quickStats: 'Estatistika azkarrak',
  recentActivity: 'Azken jarduera',
  recentResults: 'Azken emaitzak',
  upcomingMatches: 'Hurrengo partidak',
  todayMatches: 'Gaurko partidak',

  // Organizaciones
  organization: 'Erakundea',
  newOrganization: 'Erakunde berria',
  editOrganization: 'Erakundea Editatu',
  noOrganizations: 'Ez dago erakundeik',
  createFirstOrg: 'Sortu zure lehen erakundea hasteko',
  orgNamePlaceholder: 'Erakundearen izena',
  orgDescPlaceholder: 'Deskribapen laburra',
  allOrganizations: 'Erakunde guztiak',

  // Confirmaciones de generación
  generateCalendarMessage: 'Partiden egutegia sortu? Dauden partidak gainidatz ditzake.',
  generateKnockoutMessage: 'Kanporaketa sortu sailkatutako taldeekin?',
  deleteEventConfirmMessage: 'Gertaera hau ezabatu partidatik?',

  // Torneos
  tournament: 'Txapelketa',
  newTournament: 'Txapelketa berria',
  editTournament: 'Txapelketa Editatu',
  noTournaments: 'Ez dago txapelketarik',
  createFirstTournament: 'Sortu zure lehen txapelketa',
  statusUpcoming: 'Laster',
  statusOngoing: 'Abian',
  statusFinished: 'Amaituta',
  tournamentName: 'Txapelketaren izena',
  tournamentFormat: 'Formatua',
  league: 'Liga',
  cup: 'Kopa',
  groups: 'Multzoak',
  startDate: 'Hasiera data',
  endDate: 'Amaiera data',
  registrationOpen: 'Izen-ematea irekita',
  sport: 'Kirola',
  selectSport: 'Kirola aukeratu',
  selectOrganization: 'Erakundea aukeratu',
  selectTournament: 'Txapelketa aukeratu',
  season: 'Denboraldia',
  pointsWin: 'Irabazteagatik puntuak',
  pointsDraw: 'Berdinketeagatik puntuak',
  pointsLoss: 'Galtzeagatik puntuak',

  // Equipos
  team: 'Taldea',
  newTeam: 'Talde berria',
  editTeam: 'Taldea Editatu',
  noTeams: 'Ez dago talderik',
  createFirstTeam: 'Gehitu lehen taldea txapelketara',
  teamName: 'Taldearen izena',
  shortName: 'Izen laburra',
  teamColor: 'Taldearen kolorea',
  logo: 'Ezkutua',
  group: 'Multzoa',
  contact: 'Kontaktua',
  phone: 'Telefonoa',

  // Jugadores
  player: 'Jokalaria',
  newPlayer: 'Jokalari berria',
  editPlayer: 'Jokalaria Editatu',
  noPlayers: 'Ez dago jokalaririk',
  createFirstPlayer: 'Gehitu lehen jokalaria',
  playerName: 'Jokalariaren izena',
  number: 'Dorsala',
  position: 'Posizioa',
  selectTeam: 'Taldea aukeratu',
  goals: 'Golak',
  assists: 'Asistentziak',
  yellowCards: 'Txartel horiak',
  redCards: 'Txartel gorriak',
  suspended: 'Zigortua',
  suspendedMatches: 'Zigor partidak',

  // Posiciones
  goalkeeper: 'Atezaina',
  defender: 'Defentsa',
  midfielder: 'Erdilaria',
  forward: 'Aurrelaria',

  // Partidos
  match: 'Partida',
  newMatch: 'Partida berria',
  editMatch: 'Partida Editatu',
  noMatches: 'Ez dago partidarik',
  createFirstMatch: 'Sortu lehen partida',
  homeTeam: 'Etxeko taldea',
  awayTeam: 'Kanpoko taldea',
  dateTime: 'Data eta ordua',
  location: 'Lekua',
  round: 'Jardunaldia',
  referee: 'Arbitroa',
  result: 'Emaitza',
  enterResult: 'Emaitza Sartu',
  scheduled: 'Programatuta',
  live: 'Zuzenean',
  finished: 'Amaituta',
  postponed: 'Atzeratua',
  cancelled: 'Bertan behera',
  vs: 'vs',
  generateCalendar: 'Egutegia Sortu',
  clearCalendar: 'Egutegia Garbitu',

  // Tipos de resultado
  resultIn: 'Emaitza non',
  regularTime: 'Denbora arrunta',
  overtime: 'Luzapena',
  penalties: 'Penaltiak',
  penaltiesResult: 'Penaltietan emaitza',

  // Clasificación
  standings: 'Sailkapena',
  played: 'Jokatuak',
  won: 'IG',
  drawn: 'BE',
  lost: 'GL',
  goalsFor: 'GA',
  goalsAgainst: 'GK',
  goalDifference: 'DA',
  points: 'Ptu',

  // Usuarios
  user: 'Erabiltzailea',
  newUser: 'Erabiltzaile berria',
  editUser: 'Erabiltzailea Editatu',
  noUsers: 'Ez dago erabiltzailerik',
  email: 'Emaila',
  role: 'Rola',
  admin: 'Administratzailea',
  editor: 'Editorea',
  viewer: 'Ikuslea',
  approved: 'Onartuta',
  pending: 'Zain',
  assignOrganizations: 'Erakundeak esleitu',

  // Público
  selectSportTitle: 'Kirola aukeratu',
  availableTournaments: 'Txapelketa erabilgarriak',
  noActiveTournaments: 'Ez dago txapelketa aktiborik',
  viewTournament: 'Txapelketa ikusi',
  calendar: 'Egutegia',
  results: 'Emaitzak',

  // Deportes
  football: 'Futbola',
  basketball: 'Saskibaloia',
  volleyball: 'Boleibola',
  tennis: 'Tenisa',
  handball: 'Eskubaloia',
  hockey: 'Hockeya',
  rugby: 'Errugbia',
  baseball: 'Beisbola',
  futsal: 'Areto Futbola',
  football7: 'Futbol 7',
  football11: 'Futbol 11',
  pelota: 'Pilota',
  beach: 'Hondar Futbola',
  beachVolley: 'Hondar Boleibola',
  beachSoccer: 'Hondar Futbola',
  padel: 'Padela',
  tableTennis: 'Mahai Tenisa',
  badminton: 'Badmintona',
  waterpolo: 'Waterpolo',
  fieldhockey: 'Belar Hockey',
  americanFootball: 'Futbol Amerikarra',
  cricket: 'Kriketa',
  rowing: 'Arrauna',
  swimming: 'Igeriketa',
  cycling: 'Txirrindularitza',
  athletics: 'Atletismoa',
  gymnastics: 'Gimnastika',
  boxing: 'Boxeoa',
  wrestling: 'Borroka',
  judo: 'Judoa',
  karate: 'Karatea',
  taekwondo: 'Taekwondoa',
  fencing: 'Eskrima',
  archery: 'Arku Tiroa',
  shooting: 'Tiro Olinpikoa',
  equestrian: 'Zaldiketa',
  golf: 'Golfa',
  sailing: 'Bela',
  canoeing: 'Piragüismoa',
  surfing: 'Surfa',
  skateboarding: 'Skateboard',
  climbing: 'Eskalada',
  skiing: 'Eskia',
  icehockey: 'Izotz Hockeya',
  figureskating: 'Izotz Patinajea',
  curling: 'Curling',
  bobsled: 'Bobsled',
  biathlon: 'Biatloia',
  esports: 'eSportak',
  chess: 'Xakea',
  darts: 'Dardoak',
  billiards: 'Billarra',
  bowling: 'Boloak',
  pelotaVasca: 'Pilota',

  // Configuración de desempate
  tiebreaker: 'Berdinketarako',
  tiebreakerCriteria: 'Berdinketa irizpideak',
  headToHead: 'Aurrez aurreko emaitza',
  goalDiff: 'Gol diferentzia',
  goalsScored: 'Golak aldeko',
  awayGoals: 'Kanpoko golak',

  // Estadísticas
  stats: 'Estatistikak',
  totalGoals: 'Gol guztira',
  avgGoals: 'Batez besteko golak',
  cleanSheets: 'Ate garbian',

  // Tiempo
  today: 'Gaur',
  tomorrow: 'Bihar',
  yesterday: 'Atzo',
  thisWeek: 'Aste honetan',
  nextWeek: 'Hurrengo astean',

  // Acciones rápidas
  quickAdd: 'Batzuk gehitu',
  quickAddTeams: 'Talde batzuk gehitu',
  quickAddPlayers: 'Jokalari batzuk gehitu',
  teamsPlaceholder: 'Talde bat lerro bakoitzeko...\n\nAdibidea:\nAthletic Club\nReal Sociedad\nOsasuna',
  playersPlaceholder: 'Jokalari bat lerro bakoitzeko (izena edo izena, dorsala)...\n\nAdibidea:\nMuniain, 10\nOyarzabal, 7\nWilliams',
  linesProcessed: 'lerro prozesatuta',
  teamsCreated: 'talde sortu dira',
  playersCreated: 'jokalari sortu dira',

  // Calendario
  calendarSettings: 'Egutegia Konfiguratu',
  calendarFormat: 'Formatua',
  roundRobin: 'Liga (denak denon aurka)',
  knockout: 'Kanporaketa',
  singleRound: 'Joan bakarrik',
  doubleRound: 'Joan eta etorri',
  groupsKnockout: 'Multzoak + Kanporaketak',
  shuffleTeams: 'Bikoteak zozkatu',
  thirdPlaceMatch: 'Hirugarren postuaren partida',
  knockoutBracketInfo: '{teams} taldeentzako bracket-a sortuko da',
  numberOfGroups: 'Multzo kopurua',
  qualifiedPerGroup: 'Multzoko sailkatuak',
  doubleRoundGroups: 'Joan eta etorri taldeetan',
  qualified: 'Sailkatuak',
  generateKnockout: 'Kanporaketak sortu',
  scheduleSettings: 'Data konfigurazioa',
  knockoutMatchesGenerated: 'kanporaketa partida sortu dira',
  confirmGenerateKnockout: 'Kanporaketa partidak sortu sailkatutako taldeekin?',
  notEnoughQualified: 'Ez dago nahikoa talde sailkatuta',
  final: 'Finala',
  semifinal: 'Finalerdia',
  cuartos: 'Laurden Finala',
  octavos: 'Zortziren Finala',
  dieciseisavos: 'Hamaseirenfinala',
  tercer_puesto: 'Hirugarren Postua',
  bracket: 'Kanporaketak',
  groupPhase: 'Multzo Fasea',
  knockoutPhase: 'Kanporaketa Fasea',
  winner: 'Irabazlea',
  vsShort: 'vs',
  matchOrder: 'Partiden ordena',
  randomOrder: 'Ausazkoa',
  registrationOrder: 'Izen-emate ordenan',
  daysBetweenRounds: 'Jardunaldien arteko egunak',
  defaultTime: 'Ordu lehenetsia',
  defaultLocation: 'Leku lehenetsia',
  deleteExisting: 'Dauden partidak ezabatu',
  deleteExistingHint: 'Txapelketako partida guztiak ezabatuko dira berri berriak sortu aurretik',
  generate: 'Sortu',
  matchesGenerated: 'partida sortu dira',
  needTwoTeams: 'Gutxienez 2 talde behar dituzu',
  selectTournamentFirst: 'Aukeratu txapelketa lehenengo',
  selectTeamFirst: 'Aukeratu taldea lehenengo',
  confirmGenerate: 'Egutegia sortu? Ekintza hau ezin da desegin.',
  roundN: 'Jardunaldia',

  // Público
  publicSubtitle: 'Kirol txapelketen kudeaketa',
  chooseSport: 'Aukeratu kirol bat',
  activeSports: 'Txapelketa aktiboak dituzten kirolak',
  allSports: 'Beste kirolak',
  checkBackLater: 'Itzuli laster txapelketa erabilgarriak ikusteko',
  tournamentsCount: 'txapelketa',
  noUpcomingMatches: 'Ez dago hurrengo partidarik',
  noRecentResults: 'Ez dago azken emaitzarik',
  selectTournamentHint: 'Aukeratu txapelketa bat xehetasun gehiago ikusteko',
  noDescription: 'Deskribapenik gabe',
  standingsTab: 'Sailkapena',
  matchesTab: 'Partidak',
  scorers: 'Goleatzaileak',
  teamsTab: 'Taldeak',
  shareText: 'Ikusi {name} txapelketa!',
  noMatchesYet: 'Oraindik ez dago programatutako partidarik',
  noTeamsYet: 'Oraindik ez dago izena eman duen talderik',
  roundLabel: 'Jardunaldia',
  groupLabel: 'Multzoa',

  // Goleadores y eventos
  scorer: 'Goleatzailea',
  assistant: 'Asistentzia',
  minute: 'Minutua',
  ownGoal: 'Ate propioan',
  penalty: 'Penaltia',
  noEvents: 'Ez dago ekitaldirik erregistratuta',
  topScorers: 'Goleatzaile nagusiak',
  topAssisters: 'Asistente nagusiak',

  // Traducciones adicionales
  activeTournaments: 'Txapelketa aktiboak',
  addGoal: 'Gola gehitu',
  addPlayersToTeam: 'Jokalariak taldera gehitu',
  allowDraw: 'Berdinketa onartu',
  allowDrawHint: 'Desaktibatuta badago, partidek irabazlea izan behar dute',
  approve: 'Onartu',
  approvedSuccess: 'Erabiltzailea ondo onartu da',
  authorizedOnly: 'Baimendutako erabiltzaileak soilik',
  awayGoalsHint: 'Berdinketa kasuan kanpoko golak',
  awayGoalsRule: 'Kanpoko golen araua',
  cards: 'Txartelak',
  color: 'Kolorea',
  confirmDeleteMatch: 'Partida hau ezabatu?',
  confirmDeleteOrg: 'Erakunde hau ezabatu?',
  confirmDeletePlayer: 'Jokalari hau ezabatu?',
  confirmDeleteTeam: 'Talde hau ezabatu?',
  confirmDeleteUser: 'Erabiltzaile hau ezabatu?',
  continueWith: 'Jarraitu honekin',
  createFirstOrganization: 'Sortu zure lehen erakundea',
  createFirstUser: 'Sortu lehen erabiltzailea',
  delegateName: 'Delegatuaren izena',
  emailAndNameRequired: 'Emaila eta izena beharrezkoak dira',
  emailExists: 'Email hau dagoeneko erregistratuta dago',
  fillAllFields: 'Bete derrigorrezko eremu guztiak',
  fiveSets: 'Bost set',
  format: 'Formatua',
  fourQuarters: 'Lau laurden',
  fullName: 'Izen osoa',
  knockoutSettings: 'Kanporaketa ezarpenak',
  loginError: 'Errorea saioa hastean',
  lossInOvertime: 'Galera luzapenean',
  lossInPenalties: 'Galera penaltietan',
  matchDuration: 'Partidaren iraupena',
  matchEvents: 'Partidaren gertaerak',
  matchSettings: 'Partida ezarpenak',
  matchday: 'Itzulia',
  minutes: 'minutu',
  nameAndTeamRequired: 'Izena eta taldea beharrezkoak dira',
  nameRequired: 'Izena beharrezkoa da',
  noAccount: 'Ez duzu konturik?',
  noCards: 'Txartelik gabe',
  noCardsYet: 'Ez dago txartelik erregistratuta',
  noGoalsYet: 'Ez dago golik erregistratuta',
  noMatchesScheduled: 'Ez dago partidarik programatuta',
  noPermissionSection: 'Ez duzu atal hau ikusteko baimenik',
  noScorers: 'Ez dago goleatzailerik',
  noTeamsInTournament: 'Ez dago talderik txapelketa honetan',
  none: 'Bat ere ez',
  organizationName: 'Erakundearen izena',
  overtimeAvailable: 'Luzapena erabilgarri',
  overtimeDuration: 'Luzapenaren iraupena',
  overtimePenalties: 'Luzapena eta penaltiak',
  password: 'Pasahitza',
  passwordRequired: 'Pasahitza beharrezkoa da',
  passwordTooShort: 'Pasahitzak gutxienez 6 karaktere izan behar ditu',
  passwordHint: 'Erabiltzaileak pasahitz hau erabiliko du sartzeko',
  leaveEmptyToKeep: 'Utzi hutsik mantentzeko',
  userCreatedSuccess: 'Erabiltzailea ondo sortua',
  accountActivated: 'Kontua ondo aktibatua',
  penaltiesAvailable: 'Penaltiak erabilgarri',
  pendingApproval: 'Onarpenaren zain',
  pendingInvitations: 'Gonbidapen zain',
  invited: 'Gonbidatua',
  invitationCreated: 'Gonbidapena ondo sortua',
  inviteUser: 'Erabiltzailea gonbidatu',
  sendInvitation: 'Gonbidapena bidali',
  inviteUserHint: 'Erabiltzaileak email honekin erregistratzean sartu ahal izango da',
  optionalName: 'Izena (aukerakoa)',
  emailRequired: 'Emaila beharrezkoa da',
  waitingRegistration: 'Erregistroaren zain',
  pendingRequests: 'Eskaerak zain',
  periods: 'Aldiak',
  pivot: 'Pibota',
  reject: 'Baztertu',
  rejectedSuccess: 'Erabiltzailea baztertua',
  scoring: 'Puntuazioa',
  select: 'Aukeratu',
  selectTeamOrAddPlayers: 'Aukeratu talde bat edo gehitu jokalariak',
  sessionStarted: 'Saioa hasita',
  squad: 'Plantilla',
  statistics: 'Estatistikak',
  threePeriods: 'Hiru aldi',
  tournamentActive: 'Txapelketa aktiboa',
  tournamentConfig: 'Txapelketaren konfigurazioa',
  tournamentDescription: 'Txapelketaren deskribapena',
  twoLegs: 'Joan-etorria',
  twoPeriods: 'Bi aldi',
  universal: 'Unibertsala',
  unspecified: 'Zehaztu gabe',
  userActive: 'Erabiltzaile aktiboa',
  userCanAccess: 'Erabiltzaileak sar daiteke',
  userNotFound: 'Erabiltzailea ez da aurkitu',
  winInOvertime: 'Garaipena luzapenean',
  winInPenalties: 'Garaipena penaltietan',
  winger: 'Hegalaria',
  wrongPassword: 'Pasahitz okerra',

  // Tarjetas
  yellowCard: 'Txartel horia',
  redCard: 'Txartel gorria',
  secondYellow: 'Bigarren horia',
  addCard: 'Txartela gehitu',
  cardType: 'Txartel mota',
  cardsReceived: 'Jasotako txartelak',
  suspendedPlayers: 'Jokalari zigortuak',
  accumulatedCards: 'Metatutako txartelak',
  sanctionLimit: 'Zigorraren muga',
  matchesSuspended: 'Zigorraren partidak',

  // Talde-ezkutuak (crest). Torneo/org logoak beherago daude.
  teamLogo: 'Taldearen ezkutua',
  uploadTeamLogo: 'Ezkutua igo',
  changeTeamLogo: 'Ezkutua aldatu',
  removeLogo: 'Ezkutua kendu',
  logoUploaded: 'Ezkutua ondo igo da',
  logoRemoved: 'Ezkutua ezabatuta',
  invalidImageFormat: 'Irudi formatu baliogabea',
  imageTooLarge: 'Irudia handiegia da (max. 2MB)',

  sports: 'Kirolak',
  openRegistrations: 'Izen-emate irekiak',
  noOpenRegistrations: 'Ez dago izen-emate irekirik',
  signUp: 'Izena eman',
  registrations: 'Izen-emateak',
  groupPhaseLabel: 'Multzo fasea',
  knockoutPhaseLabel: 'Kanporaketak',
  mvpTitle: 'Jokalari Baliotsuena',
  mvpScoring: 'MVP puntuazioa: Asmatzea = 3ptu | Asistentzia = 2ptu | Horia = -1ptu | Gorria = -3ptu',
  noMvpData: 'Oraindik ez dago datu nahikorik',
  noAssistsYetFull: 'Oraindik ez dago asistentziarik',
  assistsShort: 'asist.',
  formNotFound: 'Formularioa ez da aurkitu',
  formLoadError: 'Errorea formularioa kargatzean',
  teamNameRequired: 'Taldearen izena derrigorrezkoa da',
  contactNameRequired: 'Kontaktuaren izena derrigorrezkoa da',
  addAtLeastOnePlayer: 'Gehitu gutxienez jokalari bat',
  checkCaptcha: 'Markatu "Ez naiz robota" laukia',
  submitError: 'Errorea izen-ematea bidaltzean. Saiatu berriro.',
  goHome: 'Hasierara joan',
  registrationsClosed: 'Izen-emateak itxita',
  registrationDeadlinePassed: 'Txapelketa honetako izen-emate epea amaitu da.',
  deadlineExpired: 'Epea amaituta',
  deadlineExpiredMsg: 'Izen-emateko azken eguna igaro da.',
  registrationSent: 'Izen-ematea bidalita',
  registrationConfirmMsg: 'Antolatzaileak zure izen-ematea berrikusiko du eta zurekin harremanetan jarriko da.',
  shareRegistration: 'Izen-ematea partekatu',
  closingSoon: 'Laster itxiko da',
  closingIn: 'Izen-emateak ixteko',
  days: 'egun',
  hours: 'ordu',
  min: 'min',
  sec: 'seg',
  registrationForm: 'Izen-emate formularioa',
  teamNameLabel: 'Taldearen izena',
  teamNamePlaceholder: 'Zure taldearen izena',
  contactNameLabel: 'Delegatu/kontaktuaren izena',
  contactNamePlaceholder: 'Zure izen osoa',
  // phone/playerName ya declarados arriba en la sección Taldeak/Jokalariak.
  emailLabel: 'Emaila',
  playersMax: 'Jokalariak (max. {max})',
  positionLabel: 'Posizioa',
  posGoalkeeper: 'Atezaina',
  posDefender: 'Itxiera',
  posWinger: 'Hegala',
  posPivot: 'Pibota',
  posUniversal: 'Unibertsala',
  playersHint: 'Bete bakarrik baieztatuta dituzun jokalariak. Errenkada hutsak utzi ditzakezu.',
  commentsLabel: 'Iruzkinak / Oharrak',
  commentsPlaceholder: 'Informazio gehigarria...',
  sending: 'Bidaltzen...',
  sendRegistration: 'Izen-ematea bidali',
  shareBtn: 'Partekatu',
  // Public registration — jokalari eremuak / mezuak / taula goiburuak
  playerLastName: 'Abizenak',
  playerDni: 'NAN / Pasaportea',
  playerBirthDate: 'Jaiotze data',
  playerBirthDateShort: 'Jaiotze d.',
  playerNumber: 'Zenbakia',
  playerSize: 'Neurria',
  playerEmail: 'Emaila',
  playerPhone: 'Telefonoa',
  playerN: 'JOKALARIA',
  playersTitle: 'Jokalariak',
  playersTitleMinMax: 'gutx. {min}, geh. {max}',
  playersTitleMax: 'geh. {max}',
  phoneRequired: 'Telefonoa derrigorrezkoa da',
  // emailRequired ya declarado arriba.
  minPlayersError: 'Gutxienez {min} jokalari eman behar dituzu izena. {filled} bete dituzu.',
  missingFieldOfPlayer: '{n}. jokalariaren {field} falta da',
  playerValidationPrefix: '{n}. jokalaria',
  vName: 'izena',
  vLastName: 'abizenak',
  vDni: 'NAN/Pasaportea',
  vBirthDate: 'jaiotze data',
  vNumber: 'zenbakia',
  vPosition: 'postua',
  vSize: 'neurria',
  vEmail: 'emaila',
  vPhone: 'telefonoa',
  dniLetterError: '{value} NAN-aren letra ez da zuzena ({expected} izan beharko luke)',
  nieLetterError: '{value} NIE-aren letra ez da zuzena ({expected} izan beharko luke)',
  inscriptionsNotInPlan: 'Online izen-emateak ez daude eskuragarri txapelketa honetarako. Jarri harremanetan zuzenean antolakuntzarekin.',
  captchaServerFailed: 'Segurtasun egiaztapenak huts egin du. Markatu berriro "Ez naiz robota" eta bidali berriro.',
  deadlinePassedError: 'Izen-emateko epea amaitu da.',
  tooManyAttempts: 'Email honekin azkenaldian izen-emate gehiegi bidali dituzu. Saiatu geroago.',
  formNotFoundReload: 'Formularioa ez dago eskuragarri. Birkargatu orria.',
  submitErrorRetry: 'Markatu captcha berriro eta saiatu berriro.',
  waitlistTitle: 'Itxaron-zerrendan zaude',
  waitlistMessage: '"{title}"-rako plazak beteta zeuden, baina zure "{team}" taldea itxaron-zerrendan geratu da. Plazaren bat askatzen bada jakinaraziko dizugu.',
  registrationSentMessage: 'Zure "{team}" taldea behar bezala eman da izena "{title}"-n.',
  backToTournaments: 'Txapelketetara itzuli',
  backShort: 'Itzuli',
  seatsFull: 'Plazak beteta ({current}/{max})',
  seatsCounter: '{current} / {max} plazatik — {remaining} geratzen dira',
  waitlistNote: 'Orain izena ematen baduzu, itxaron-zerrendan geratuko zara.',
  whatsappShareText: '{title}-n izena eman dugu! 🏆\n\nEman izena zuk ere:\n{url}',
  captchaLoadFailed: 'Ezin izan da segurtasun egiaztapena kargatu (zure sareak edo nabigatzaileko luzapen batek eragotzi dezake). Saiatu orria birkargatzen edo jarri harremanetan zuzenean txapelketaren antolakuntzarekin.',
  legalConsentText: 'Formulario hau bidaltzean, emandako datuak (taldearen izena barne) txapelketaren antolakuntzak berrikusiko dituela eta webean argitaratu daitezkeela onartzen duzu. TorneosPro plataforma teknologiko gisa baino ez da aritzen eta ez da erabiltzaileek sartutako edukiaren ezta antolakuntzaren erabakien arduradun. Begiratu gure',
  privacyPolicyLink: 'pribatutasun politika',
  phonePlaceholder: '600 000 000',
  emailPlaceholderExample: 'zure@email.eus',
  privacyPolicy: 'Pribatutasun Politika',
  legalNotice: 'Lege Oharra',
  cookiePolicy: 'Cookie Politika',
  privacy: 'Pribatutasuna',
  legalShort: 'Lege oharra',
  cookies: 'Cookieak',

  // Admin - Tournaments
  onlyImagesAllowed: 'Irudiak bakarrik onartzen dira',
  imageMaxSize500: 'Irudiak ezin du 500KB gainditu',
  tournamentLogo: 'Txapelketaren logoa',
  changeLogo: 'Logoa aldatu',
  uploadLogo: 'Logoa igo',
  removeLogoBtn: 'Logoa kendu',
  tiebreakerTab: 'Berdinketa apurtzea',
  visibilityTab: 'Ikusgaitasuna',
  tiebreakerHint: 'Bi talde puntuetan berdinduta daudenean aplikatzen diren irizpideen ordena. Lehenengoak lehentasuna du.',
  tbPoints: 'Puntuak',
  tbHeadToHead: 'Aurrez aurreko emaitza',
  tbGoalDifference: 'Gol-diferentzia',
  tbGoalsFor: 'Aldeko golak',
  tbGoalsAgainst: 'Kontrako golak',
  tbWins: 'Garaipenak',
  tbLosses: 'Porrotak (gutxiago = hobe)',
  tbPointsDifference: 'Puntu-diferentzia',
  tbPointsFor: 'Aldeko puntuak',
  tbSetsDifference: 'Set-diferentzia',
  tbSetsFor: 'Irabazitako setak',
  tbRandom: 'Zozketa',
  tbLossesShort: 'Porrotak',
  tbPointsDifferenceShort: 'Ptu. dif.',
  tbSetsDifferenceShort: 'Set dif.',
  tbRandomShort: 'Zozketa',
  addCriterion: 'Irizpidea gehitu:',
  visibilityHint: 'Hautatu zer atal agertuko diren txapelketaren gune publikoan.',
  visTabStandings: 'Sailkapena',
  visTabGroups: 'Multzoak',
  visTabBracket: 'Kanporaketa-koadroa',
  visTabMatches: 'Partidak',
  visTabScorers: 'Gol-egile onenak',
  visTabAssists: 'Asistentziak',
  visTabMvp: 'MVP',
  visTabFairplay: 'Fair Play',
  visTabTeams: 'Taldeak',
  notAvailableFormat: '(ez dagokio formatu honi)',

  // Admin - Teams
  selectTournamentFirstMsg: 'Hautatu txapelketa bat lehenengo',
  needTwoTeamsMsg: 'Gutxienez 2 talde behar dituzu',
  maxEightGroups: 'Gehienez 8 talde',
  groupsSavedOk: 'Multzoak ondo gorde dira',
  selectTargetTournament: 'Hautatu helburuko txapelketa',
  selectAtLeastOneTeam: 'Hautatu gutxienez talde bat',
  teamsImportedWithPlayers: 'talde inportatuak jokalariekin',
  importPartialPlayersWarning: 'Kontuz: jokalari batzuk ezin izan dira kopiatu. Taldeak ondo inportatu dira.',
  importNoPlayersFound: 'Jatorrizko txapelketako taldeek ez zuten jokalaririk kopiatzeko.',
  importBtn: 'Inportatu',
  groupsBtn: 'Multzoak',
  groupsLabel2: 'Multzoak: ',
  deleteGroupTitle: 'Multzoa ezabatu',
  removeFromGroupTitle: 'Multzotik kendu',
  importTeamsFromTournament: 'Beste txapelketa bateko taldeak inportatu',
  teamsLowercase: 'talde',
  deselectAll: 'Guztiak desautatu',
  selectAll: 'Guztiak hautatu',

  // Admin - Players
  bulkPlayersPlaceholder: 'Jon Garcia, 7, Atezaina\nPello Lopez, 10, Hegala\nMikel Ruiz, 5\nAnder Torres',
  bulkPlayersFormat: 'Formatua: Izena, Zenbakia, Posizioa (zenbakia eta posizioa aukerakoak dira)',

  // Admin - Matches
  generateKnockoutTitle: 'Kanporaketak sortu',
  generateKnockoutMsg: 'Kanporaketak sortuko dira',
  qualifiedTeamsText: 'talde sailkaturekin',
  perGroupText: 'talde bakoitzeko',
  generateBtn: 'Sortu',

  // Admin - Users / Mesa
  pinCodeLabel: 'PIN kodea',
  pinCopied: 'PIN kopiatuta',
  regeneratePin: 'Berriz sortu',
  mesaUrlHint: 'Mahaia URL horretan sartzen da eta PIN kode hau jartzen du.',
  mesaWhatsappPrefix: 'Partidu mahaia - ',
  mesaWhatsappEnter: 'Sartu: torneospro.com/#/mesa',
  mesaWhatsappPin: 'PIN kodea: ',
  copyWhatsappData: 'WhatsApp-erako datuak kopiatu',

  // Admin - Forms
  deleteFormTitle: 'Formularioa ezabatu',
  createTeamFromRegistration: 'Izen-ematetik taldea sortu',
  deleteRegistrationTitle: 'Izen-ematea ezabatu',
  registrationDeleted: 'Izen-ematea ezabatuta',
  changeImage: 'Irudia aldatu',
  uploadImage: 'Irudia igo',
  deleteBtn: 'Ezabatu',
  registrationReceivedAt: 'Izen-ematea jasota: ',

  // Admin - Settings
  configSaved: 'Konfigurazioa gorde da',
  configTitle: 'Konfigurazioa',
  configSubtitle: 'Plataformaren ezarpen orokorrak',
  visibleSportsTitle: 'Home publikoan ikusgai dauden kirolak',
  visibleSportsHint: 'Hautatu zer kirol agertzen diren orrialde publikoan. Markatu gabe daudenak ez dira agertuko txapelketak izan arren.',

  // Admin - System
  repairProblem: 'Arazoa konpondu',
  deleteOrphanEvent: 'Gertaera umezurtz hau ezabatu?',
  deleteProblemDoc: 'Arazoa duen dokumentua ezabatu?',
  repairAll: 'Dena konpondu',
  willDeleteDocs: 'Ezabatuko dira',
  docsWithProblems: 'arazoa duten dokumentu. Jarraitu?',
  backupDownloaded: 'Backup-a deskargatuta',
  resetTournamentTitle: 'Txapelketa berrezarri',
  resetTournamentMsg: 'TXAPELKETA HONETAKO emaitza, gertaera eta partidu guztiak ezabatuko dira:',
  resetTournamentKeep: 'Taldeak eta jokalariak mantenduko dira. Jarraitu?',
  maintenanceOn: 'Mantentze modua aktibatuta',
  maintenanceOff: 'Mantentze modua desaktibatuta',
  systemSubtitle: 'Mantentze eta diagnostiko tresnak',
  systemTabHealth: 'Osasuna',
  systemTabErrors: 'Erroreak',
  systemTabBackup: 'Backup',
  systemTabTools: 'Tresnak',
  systemTabMaintenance: 'Mantentzea',
  scanning: 'Eskaneatzen...',
  scan: 'Eskaneatu',
  pressScanHint: 'Sakatu "Eskaneatu" datu-basea berrikusteko',
  noErrorsPending: 'Ez dago konpondu gabeko errorerik',
  backupHint: 'Plataformaren datu guztien kopia osoa JSON formatuan deskargatu.',
  exporting: 'Esportatzen...',
  downloadFullBackup: 'Backup osoa deskargatu',
  backupIncludes: 'Barne hartzen ditu: txapelketak, taldeak, jokalariak, partidak, gertaerak, erakundeak, erabiltzaileak, formularioak eta izen-emateak.',
  resetTournamentCard: 'Txapelketa berrezarri',
  resetTournamentCardDesc: 'Emaitzak, partidak eta gertaerak ezabatzen ditu. Taldeak eta jokalariak mantentzen ditu.',
  resetBtn: 'Berrezarri',
  duplicateTournamentCard: 'Txapelketa bikoiztu',
  duplicateTournamentCardDesc: 'Txapelketa osoa taldeekin eta jokalariekin kopiatzen du denboraldi berrirako.',
  duplicateBtn: 'Bikoiztu',
  maintenanceMode: 'Mantentze modua',
  maintenanceHint: 'Aktibatuta dagoenean, erabiltzaile publikoek "Mantentzean" mezua ikusten dute aplikazioaren ordez.',
  maintenanceActivated: 'AKTIBATUTA',
  maintenanceDeactivated: 'DESAKTIBATUTA',
  disableMaintenance: 'Mantentzea desaktibatu',
  enableMaintenance: 'Mantentzea aktibatu',
  resetModalHint: 'Partidu, emaitza eta gertaera guztiak ezabatuko dira. Taldeak eta jokalariak 0 estatistikekin mantenduko dira.',
  copySuffix: '(kopia)',
  duplicateHint: 'Taldeak eta jokalariak kopiatuko dira. Estatistikak 0, partidarik gabe.',

  // Admin - Organizations
  cityTown: 'Herria / Hiria',

  // Admin - Dashboard
  viewTournamentsBtn: 'Txapelketak ikusi',
  viewMatchesBtn: 'Partidak ikusi',

  // ============================================================
  // Web publiko marketing-zonea
  // ============================================================

  // Web - Layout (navbar, footer)
  webDefaultDescription: '12 kiroletako txapelketak kudeatu: futbola, areto futbola, saskibaloia, boleibola, tenisa, padela, eskubaloia, hockeya, errugbia, pilota eta gehiago. Online izen-emateak, egutegiak eta sailkapenak denbora errealean. Herri, klub eta udalentzat.',
  webDefaultTitleSuffix: 'Kirol txapelketen kudeaketa',
  webNavProduct: 'Produktua',
  webNavHome: 'Hasiera',
  webNavPricing: 'Prezioak',
  webNavGallery: 'Galeria',
  webNavContact: 'Kontaktua',
  webNavFeatures: 'Ezaugarriak',
  webNavHowItWorks: 'Nola funtzionatzen du',
  webNavForOrgs: 'Norentzat da',
  webNavFAQShort: 'FAQ',
  webNavFAQLong: 'Ohiko galderak',
  webNavSubFeaturesDesc: 'Egin dezakezun guztia',
  webNavSubHowItWorksDesc: 'Hasteko urratsak',
  webNavSubForOrgsDesc: 'Herriak, klubak, udalak',
  webNavSubFAQDesc: 'Ohiko zalantzak',
  webNavViewTournaments: 'Txapelketak ikusi',
  webNavLoginToPanel: 'Panelera sartu',
  webMenuAria: 'Menua',
  webFooterTagline: 'Herri, klub eta udaletan kirol txapelketak kudeatzeko plataforma.',
  webFooterColProduct: 'Produktua',
  webFooterColResources: 'Baliabideak',
  webFooterColLegal: 'Legezkoa',
  webFooterLinkLiveTournaments: 'Zuzeneko txapelketak',
  webFooterLinkPrivacy: 'Pribatutasuna',
  webFooterLinkTerms: 'Lege-oharra',
  webFooterLinkCookies: 'Cookieak',
  webFooterMadeIn: 'Espainian egina',

  // Web - Home
  webHomeTitle: 'Antolatu txapelketak profesional bat bezala',
  webHomeDescription: '12 kiroletako txapelketak kudeatu: futbola, areto futbola, saskibaloia, boleibola, tenisa, padela, eskubaloia, hockeya, errugbia, pilota eta gehiago. Online izen-emateak, egutegi automatikoak eta sailkapenak zuzenean. Herri, klub eta udalentzat.',
  webHomeBadge: 'Espainian egina · 12 kirol · Euskaraz',
  webHomeHeroLine1: 'Antolatu txapelketak',
  webHomeHeroLine2: 'profesional bat bezala',
  webHomeHeroSubtitle: 'Taldeak, jokalariak, egutegiak, kanporaketak, online izen-emateak eta emaitzak denbora errealean. Herri, klub eta udalentzat.',
  webHomeHeroCtaPricing: 'Prezioak ikusi',
  webHomeHeroCtaLive: 'Zuzeneko txapelketak ikusi',
  webHomeHeroDisclaimer: 'Ordainketa bakarra + urteko ordu-paketea · Harpidetza derrigorrezkorik gabe',
  webHomeSectionsTitle1: 'Behar duzun guztia,',
  webHomeSectionsTitle2: 'leku bakarrean',
  webHomeCardFeaturesTitle: 'Ezaugarriak',
  webHomeCardFeaturesDesc: 'TorneosPro-rekin egin dezakezun guztia',
  webHomeCardHowItWorksTitle: 'Nola funtzionatzen du',
  webHomeCardHowItWorksDesc: 'Hasteko 3 urrats sinple',
  webHomeCardForOrgsTitle: 'Norentzat da',
  webHomeCardForOrgsDesc: 'Herriak, klubak eta udalak',
  webHomeCardPricingTitle: 'Prezioak',
  webHomeCardPricingDesc: 'Abian jartze bakarra + urteko ordu-paketea',
  webHomeCardGalleryTitle: 'Galeria',
  webHomeCardGalleryDesc: 'Benetako txapelketen argazkiak',
  webHomeCardFAQTitle: 'Ohiko galderak',
  webHomeCardFAQDesc: 'Ohiko zalantzarik arruntenak',
  webHomeCardSeeMore: 'Gehiago ikusi',
  webHomeExcelTitle1: 'Agur',
  webHomeExcelTitle2: 'Excel',
  webHomeExcelTitle3: 'kaixo',
  webHomeExcelBadColumnTitle: 'Excel / WhatsApp / papera',
  webHomeExcelBad1: 'Emaitzak eskuz apuntatu',
  webHomeExcelBad2: 'Sailkapenak eskuz kalkulatu',
  webHomeExcelBad3: 'Berdinketak apurtzeko formulekin borrokan',
  webHomeExcelBad4: 'Ordu-aldaketa bakoitzeko mezu amaigabeak',
  webHomeExcelBad5: 'Jokalarien estatistikarik gabe',
  webHomeExcelBad6: 'Online izen-ematerik gabe',
  webHomeExcelGoodColumnTitle: 'TorneosPro-rekin',
  webHomeExcelGood1: 'Emaitzak denbora errealean polikiroldegitik',
  webHomeExcelGood2: 'Sailkapen automatikoa berdinketa-irizpide konfiguragarriekin',
  webHomeExcelGood3: 'Kanporaketak klik bakar batekin sortuta',
  webHomeExcelGood4: 'Izen-emate publikoak QR eta atzera-kontaketarekin',
  webHomeExcelGood5: 'Banakako estatistikak: goleatzaileak, MVP, fair play',
  webHomeExcelGood6: 'PDF eta Excel berehala esportatzeko',
  webHomeSportsTitle1: 'Edozein kirol,',
  webHomeSportsTitle2: 'zure neurrira egina',
  webHomeSportsIntro1: 'Lehenetsita honakoak ditugu',
  webHomeSportsIntro2: '12 kirol',
  webHomeSportsIntro3: 'beren terminologia, posizio eta formatu propioarekin konfiguratuta. Beste bat behar duzu? Zure erakundearentzat kosturik gabe gehituko dugu.',
  webHomeSportFutsal: 'Areto-futbola',
  webHomeSportFootball7: '7ko futbola',
  webHomeSportFootball11: '11ko futbola',
  webHomeSportBasketball: 'Saskibaloia',
  webHomeSportVolleyball: 'Boleibola',
  webHomeSportHandball: 'Eskubaloia',
  webHomeSportPadel: 'Padela',
  webHomeSportTennis: 'Tenisa',
  webHomeSportPelota: 'Pilota',
  webHomeSportRugby: 'Errugbia',
  webHomeSportHockey: 'Hockeya',
  webHomeSportBeachSoccer: 'Hondartza-futbola',
  webHomeSportYours: 'Zurea',
  webHomeSportNotListedPre: 'Zure kirola ez dago zerrendan?',
  webHomeSportNotListedAsk: 'Eskatu',
  webHomeSportNotListedPost: 'eta gehituko dugu.',
  webHomeFinalTitle: 'Hitz egiten dugu zure txapelketaz?',
  webHomeFinalSubtitle: 'Esan zer antolatu nahi duzun eta neurrira egindako aurrekontua prestatuko dizugu 24 lanordu baino gutxiagoan.',
  webHomeFinalCtaContact: 'Kontaktatu',
  // Hero — precio orientativo
  webHomeHeroPriceHint: 'Aurrekontua neurrira · Konpromisorik gabe',
  // Social proof
  webHomeProofBadge: 'PRODUKZIOAN',
  webHomeProofTitle: 'Benetako txapelketekin egina, ez maketekin',
  webHomeProofCaseLabel: 'KASU ERREALA',
  webHomeProofCaseTitle: 'Zarautzko udako areto futbol txapelketa',
  webHomeProofCaseDesc: '3 urte daramatzagu Zarautzko udako areto futbol txapelketa kudeatzen, 32 talderaino eta liga formatu desberdinekin (taldeak + kanporaketak, joan-etorria, mistoak…). Emaitzak zuzenean polideportibotik eta sailkapen publikoa WhatsApp bidez partekatuta.',
  webHomeProofStatYears: 'Urte',
  webHomeProofStatTeams: 'Talde max.',
  webHomeProofStatLive: 'Zuzenean',
  webHomeProofSupportTitle: 'Hurbileko arreta zure hizkuntzan',
  webHomeProofSupportDesc: 'Gaztelaniaz, euskaraz edo ingelesez erantzuten dizugu. Chatbot-ik gabe eta egunak luzatzen diren ticket-ik gabe: pertsonalki egiten dugu.',
  webHomeProofPaymentTitle: 'Ordainketa bakarra, sorpresarik gabe',
  webHomeProofPaymentDesc: 'Abian jartzea behin ordaindu + zuk erabakitzen duzun ordu-paketea. Urtean itotzen zaituzten harpidetza errepikakorrik gabe.',
  // Screenshots
  webHomeScreensTitle1: 'Honela ikusten da',
  webHomeScreensTitle2: 'TorneosPro',
  webHomeScreensSubtitle: 'Polikiroldegian, udaletxeko bulegoan eta semea jarraitzen duen aitaren mugikorrean ondo ikusteko diseinatua.',
  webHomeScreen1Label: 'Administrazio panela',
  webHomeScreen1Desc: 'Sortu txapelketak, taldeak eta jokalariak minutu gutxitan.',
  webHomeScreen2Label: 'Partida-mahaia',
  webHomeScreen2Desc: 'Partida-mahai bakoitza bere kodearekin sartzen da eta esleitutako partidak bakarrik ikusten ditu.',
  webHomeScreen3Label: 'Orri publikoa',
  webHomeScreen3Desc: 'Multi-kirol, izen-emateak irekita eta QR bidez partekatua.',
  webHomeScreen4Label: 'Kanporaketa bisualak',
  webHomeScreen4Desc: 'Bracket automatikoa estatistikekin, babesleekin eta goleatzaileekin.',
  webHomeScreen5Label: 'Emaitzak zuzenean',
  webHomeScreen5Desc: 'Markagailua, asistentzia, golak eta txartelak partida-mahaitik.',

  // Web - Features
  webFeaturesTitle: 'Ezaugarriak',
  webFeaturesDescription: 'TorneosPro-ren funtzionalitate guztiak: mugagabeko txapelketak, taldeak eta jokalariak, egutegi automatikoa, sailkapena zuzenean, kanporaketak, online izen-emateak, partida-mahaia, estatistikak, PDF/Excel esportatu eta gehiago.',
  webFeaturesBadge: 'EZAUGARRIAK',
  webFeaturesHeroTitle1: 'Egin dezakezun',
  webFeaturesHeroTitle2: 'guztia',
  webFeaturesHeroSubtitle: 'Excel, WhatsApp eta paperez betetako tiradera ordezkatzen dituzten 12 funtzionalitate gako.',
  webFeaturesItem1Title: 'Mugagabeko txapelketak',
  webFeaturesItem1Desc: 'Sortu nahi adina txapelketa: ligak, kanporaketak, formatu mistoak. Bakoitzak bere kirola, egutegia eta konfigurazioa.',
  webFeaturesItem2Title: 'Taldeak eta jokalariak',
  webFeaturesItem2Desc: 'Taldeen kudeaketa osoa ezkutu, kolore eta kontaktuekin. Jokalarien plantilla dorsal, posizio eta banakako estatistikekin.',
  webFeaturesItem3Title: 'Egutegi automatikoa',
  webFeaturesItem3Desc: 'Egutegiak segundu gutxitan sortu: datak, orduak eta zelai erabilgarriak sartzen dituzu. App-ak partidak jardunaldika banatzen ditu.',
  webFeaturesItem4Title: 'Sailkapena zuzenean',
  webFeaturesItem4Desc: 'Sartzen den gol bakoitzak taula eguneratzen du. Berdinketa-irizpide konfiguragarriak: puntuak, golak, aurrez aurreko emaitzak, fair play.',
  webFeaturesItem5Title: 'Kanporaketa-koadroa',
  webFeaturesItem5Desc: 'Talde-fasetik kanporaketak automatikoki sortzen ditu. Luzapena, penaltiak eta irabazlearen aurrerapen automatikoa onartzen ditu.',
  webFeaturesItem6Title: 'Online izen-emateak',
  webFeaturesItem6Desc: 'Formulario publikoak atzera-kontaketarekin, deskargagarria den QR-arekin, itxaron-zerrenda automatikoarekin eta bot-en aurkako reCAPTCHA-rekin.',
  webFeaturesItem7Title: 'Partidu mahaia',
  webFeaturesItem7Desc: 'PIN bidezko sarbidea polikiroldegian emaitzak, asistentzia, golak eta txartelak zuzenean sartzeko.',
  webFeaturesItem8Title: 'Estatistika xeheak',
  webFeaturesItem8Desc: 'Goleatzaileen, asistenteen, MVP-aren eta fair play-aren rankinga. Talde eta jardunaldika konparaketak.',
  webFeaturesItem9Title: 'PDF eta Excel-era esportatu',
  webFeaturesItem9Desc: 'Sailkapena, egutegia, taldeen fitxak eta jokalariekin plantillak berehala sortzen ditu. Orri anitzeko Excel osoa.',
  webFeaturesItem10Title: '%100 mugikorra',
  webFeaturesItem10Desc: 'Mugikorrean, tabletan eta ordenagailuan ezin hobeto funtzionatzen du. Mugikorrean app baten antzera instala daiteke. Txapelketaren jarraitzaileei abisu automatikoak Plus planean edo handiagoan daude eskuragarri.',
  webFeaturesItem11Title: 'Hizkuntza-anitza',
  webFeaturesItem11Desc: 'Gaztelania, euskara eta ingelesa. Bisitari bakoitzak app-a bere hizkuntzan ikusten du klik bakar batekin.',
  webFeaturesItem12Title: 'Online ikusgarritasuna',
  webFeaturesItem12Desc: 'Txapelketa bakoitzak bere URL publikoa du torneospro.com-en. Partekatu WhatsApp, sare sozial edo QR bidez.',
  webFeaturesCtaTitle: 'Egokitzen zaizkizu?',
  webFeaturesCtaPricing: 'Prezioak ikusi',
  webFeaturesCtaHowItWorks: 'Nola funtzionatzen du',

  // Web - HowItWorks
  webHowTitle: 'Nola funtzionatzen du',
  webHowDescription: 'Astebete baino gutxiagoan zure lehen txapelketa martxan izateko 3 urrats: aurrekontua eskatu, dena konfiguratzen dizugu eta jokatzera. Konpromisorik gabe.',
  webHowBadge: 'NOLA FUNTZIONATZEN DU',
  webHowHeroTitle1: '3 urrats',
  webHowHeroTitle2: 'hasteko',
  webHowHeroSubtitle: 'Astebete baino gutxiagoan zure lehen txapelketa martxan jarri dezakezu.',
  webHowStep1Title: 'Eskatu aurrekontua',
  webHowStep1Desc: 'Esan zer antolatu nahi duzun (jaietako txapelketa bat, udal liga bat...) eta neurrira egindako aurrekontua prestatuko dizugu 24 lanordu baino gutxiagoan. Konpromisorik gabe.',
  webHowStep2Title: 'Dena konfiguratzen dizugu',
  webHowStep2Desc: 'Sinatu ondoren, zure erakundea altan ematen dugu zure logo eta datuekin. Zurekin eta delegatuekin 1-2 prestakuntza-bideodei egiten ditugu. Zure lehen txapelketa zure ondoan konfiguratzen dugu.',
  webHowStep3Title: 'Jokatzera!',
  webHowStep3Desc: 'Partekatu txapelketaren URL publikoa edo izen-ematearen QR-a. Mahaiek polikiroldegitik sartzen dituzte emaitzak. Zuk dena denbora errealean ikusten duzu zure admin-etik.',
  webHowCtaTitle: 'Hasten gara?',
  webHowCtaSubtitle: 'Konpromisorik gabe eskatu aurrekontua eta 24 lanordu baino gutxiagoan erantzungo dizugu.',
  webHowCtaRequest: 'Aurrekontua eskatu',
  webHowCtaPricing: 'Prezioak ikusi',

  // Web - ForOrgs
  webOrgsTitle: 'Norentzat da',
  webOrgsDescription: 'TorneosPro txapelketa amateurrak antolatzen dituenarentzat pentsatuta dago: herriko jaiak, udalak, enpresak, ikastetxeak, kirol klubak, elkarteak eta peñak.',
  webOrgsBadge: 'NORENTZAT',
  webOrgsHeroTitle1: 'Ikusten zara',
  webOrgsHeroTitle2: 'horietakoren batean?',
  webOrgsHeroSubtitle: 'TorneosPro herri, klub edo udaletan txapelketa amateurrak antolatzen dituenarentzat pentsatuta dago.',
  webOrgsCase1Title: 'Herriko jaiak',
  webOrgsCase1Desc: '1.000-5.000 biztanleko herri bateko jai-batzordea, urteko areto futbol txapelketa antolatzen duena. Tabernetan itsatsitako QR bidezko izen-emateak.',
  webOrgsCase2Title: 'Udalak',
  webOrgsCase2Desc: 'Ikasturte osoan zehar paraleloan kirol askotako udal liga jarraitua. Polikiroldegi bakoitzean partida-mahaia.',
  webOrgsCase3Title: 'Enpresak',
  webOrgsCase3Desc: 'Asteburuko enpresa edo enpresa arteko txapelketa. Email bidezko izen-ematea itxia, plaza mugatuekin.',
  webOrgsCase4Title: 'Ikastetxeak eta institutuak',
  webOrgsCase4Desc: 'Klase arteko liga edo eskolako lehiaketa. Adingabeko jokalariekin plantillak, babestutako datuak.',
  webOrgsCase5Title: 'Kirol klubak',
  webOrgsCase5Desc: 'Hainbat kategoria eta sekzio dituen klub federatua. Kadete, gazte, senior eta beteranoen taldeak.',
  webOrgsCase6Title: 'Elkarteak eta peñak',
  webOrgsCase6Desc: 'Urtean behin data berezietan txapelketa amateurra antolatzen duen peña, IGE edo kultur elkartea.',
  webOrgsCtaTitle: 'Ez zaude ziur egokitzen zaren?',
  webOrgsCtaSubtitle: 'Esan zure kasua eta konpromisorik gabe esango dizugu TorneosPro egokitzen zaizun ala ez.',
  webOrgsCtaButton: 'Aurrekontua eskatu',

  // Web - FAQ
  webFAQTitle: 'Ohiko galderak',
  webFAQDescription: 'TorneosPro-ri buruzko ohiko zalantzak argitzen ditugu: prezioak, instalazioa, txapelketa anitzen kudeaketa, laguntza, datuak, partida-mahaia eta askoz gehiago.',
  webFAQBadge: 'FAQ',
  webFAQHeroTitle1: 'Ohiko',
  webFAQHeroTitle2: 'galderak',
  webFAQQ1: 'Zenbat balio du?',
  webFAQA1: 'Zure erakundearen tamainaren araberakoa da. Hasierako abian jartze bat ordaintzen duzu eta zure neurriko urteko ordu-paketea aukeratzen duzu. Ez dago harpidetza derrigorrezkorik. Esan zer antolatu nahi duzun eta aurrekontua prestatuko dizugu 24 lanordu baino gutxiagoan.',
  webFAQQ2: 'Zerbait instalatu behar dut?',
  webFAQA2: 'Ez. Edozein nabigatzailetik (Chrome, Safari, Firefox) funtzionatzen du ordenagailu, mugikor edo tabletan. Web app progresiboa (PWA) da: nahi izanez gero, mugikorrean lasterbide gisa "instala" dezakezu.',
  webFAQQ3: 'Jokalariek konturik behar al dute?',
  webFAQA3: 'Ez. Antolatzaile gisa zuk soilik. Jokalariek eta ikusleek esteka publiko bidez sartzen dira txapelketara, erregistratu gabe.',
  webFAQQ4: 'Hainbat txapelketa kudeatu ditzaket aldi berean?',
  webFAQA4: 'Bai, nahi adina. Bakoitza bere kirol, formatu, talde eta konfigurazio independenteekin.',
  webFAQQ5: 'Zer gertatzen da nire datuekin?',
  webFAQA5: 'Firebase-n (Google Cloud) seguru gordetzen dira sarbide-arau zorrotzekin. Backup osoa nahi duzunean deskarga dezakezu.',
  webFAQQ6: 'Laguntza teknikoa al dago?',
  webFAQA6: 'Bai. info@torneospro.com helbidera idatzi dezakezu eta 24 lanordu baino gutxiagoan erantzuten dugu. Ordu-paketeek WhatsApp/email bidezko laguntza biltzen dute.',
  webFAQQ7: '30 edo 60 eguneko ordainketa onartzen al duzue?',
  webFAQA7: 'Bai, bereziki aurrekontua duten udalentzat eta erakunde publikoentzat. Behar duzun dokumentazio administratibo guztia ematen dizugu.',
  webFAQQ8: 'Txapelketaren formatua aldatu dezaket hasi ondoren?',
  webFAQA8: 'Hobe ez. Liga-tik Kanporaketa-ra aldatzen baduzu jokatutako partidekin, sailkapenak hautsiko dira. Aldatu behar baduzu, esportatu lehenik datuak.',
  webFAQQ9: 'Nire txapelketaren datuak deskargatu ditzaket?',
  webFAQA9: 'Bai, txapelketa bakoitzean "Esportatu" botoia → PDF sortzen du (sailkapena, goleatzaileak, egutegia, taldeak) eta orri guztiekin Excel osoa.',
  webFAQQ10: 'Nola funtzionatzen du partida-mahaiak?',
  webFAQA10: 'Panel sinplifikatu bat da, torneospro.com/mesa-tik 6 zifrako PIN batekin sartzen dena. Pertsonak esleitutako partidak bakarrik ikusten ditu eta asistentzia, golak eta txartelak zuzenean sartzen ditu.',
  webFAQQ11: 'App natiborik baduzue?',
  webFAQA11: 'Ez, baina weba ezin hobeto funtzionatzen du instalagarria den app gisa (PWA). iPhone-an Safari-tik gehitzen da → Partekatu → Hasierako pantailan gehitu.',
  webFAQQ12: 'Jakinarazpenak jasoko ditut taldeek izena ematen dutenean?',
  webFAQA12: 'Modulu hori amaitzen ari gara. Une honetan abisua jasotzen duzu admin-era sartzean zain dauden izen-emateen kontagailuarekin.',
  webFAQCtaTitle: 'Zure galdera ez dago hor?',
  webFAQCtaButton: 'Galdetu zuzenean',

  // Web - Contact
  webContactTitle: 'Kontaktua',
  webContactDescription: 'Esan zer antolatu nahi duzun eta neurrira egindako aurrekontua prestatuko dizugu 24 lanordu baino gutxiagoan. Konpromisorik gabe. info@torneospro.com',
  webContactBadge: 'KONTAKTUA',
  webContactHeroTitle1: 'Hitz egin dezagun',
  webContactHeroTitle2: 'zure txapelketaz',
  webContactHeroSubtitle: 'Esan zer antolatu nahi duzun eta neurrira egindako aurrekontua prestatuko dizugu 24 lanordu baino gutxiagoan.',
  webContactHoursLabel: 'Ordutegia:',
  webContactHoursText: 'astelehenetik ostiralera erantzuten dugu 24 lanordu baino gutxiagoan. Asteburu eta jaiegunetan denbora gehiago behar izan dezake.',

  // Web - 404
  web404Title: 'Orria ez da aurkitu',
  web404Description: 'Bilatzen ari zaren orria ez dago edo lekuz aldatu da.',
  web404HeadlinePart1: 'Orri hau',
  web404HeadlinePart2: 'zelaitik atera da',
  web404Body: 'Bilatzen ari zaren orria ez dago, lekuz aldatu da edo esteka oker idatzita dago. Lasai, hasierara eramango zaitugu.',
  web404CtaHome: 'Hasierara joan',
  web404CtaTournaments: 'Txapelketak ikusi',
  web404SuggestionsTitle: 'Hauetakoren bat bilatzen al zenuen?',
  web404SuggestPricing: 'Prezioak',
  web404SuggestFeatures: 'Ezaugarriak',
  web404SuggestGallery: 'Galeria',
  web404SuggestFAQ: 'FAQ',
  web404SuggestContact: 'Kontaktua',

  // Galeria publikoa
  galleryBadge: 'GALERIA',
  galleryHeroTitle1: 'Txapelketen',
  galleryHeroTitleHighlight: 'unerik onenak',
  galleryHeroTitle2: '',
  galleryDescription: 'TorneosPro-rekin kudeatutako benetako txapelketen argazkiak: herriko festak, udal ligak, enpresa txapelketak eta gehiago.',
  gallerySearchPlaceholder: 'Album bila txapelketa edo kirolaren arabera...',
  galleryEmptyTitle: 'Oraindik argazkirik ez',
  galleryEmptyBody: 'Laster igoko ditugu txapelketen unerik onenak.',
  galleryFeatured: 'Nabarmenduak',
  galleryAlbumsTitle: 'Txapelketa bakoitzeko albumak',
  galleryResultsCount: 'Emaitzak',
  galleryRotating: '5s-ero txandakatzen',
  galleryAlbumsTotal: 'album guztira',
  galleryNoMatch: 'Ez dago bat datorren albumik',
  galleryPhotos: 'argazki',
  gallerySport: 'Kirola',

  // Prezio publikoak
  pricingBadgePreLaunch: 'AURRE-MERKATURATZEA',
  pricingBadgeQuote: 'Aurrekontu eskaera',
  pricingBadgeSuccess: 'Eskaera jasota',
  pricingRequestQuote: 'Aurrekontua eskatu',
  pricingContactUs: 'Idatzi iezaguzu',
  pricingBuy: 'Plana erosi',
  pricingSelected: 'Aukeratutako plana',
  pricingIncluded: 'Barne:',
  pricingNotIncluded: 'Ez dago barne',
  pricingLimits: 'Mugak',
  pricingUseCase: 'Egokia:',
  pricingCta: 'Plana aukeratu',
  pricingCtaChosen: 'Plana aukeratua',
  pricingQuoteThanks: 'Eskaera jasota. Laster harremanetan jarriko gara.',
  pricingQuoteError: 'Ezin izan da eskaera bidali'
};
